// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface DrawerDownIconSignature {
  Element: SVGSVGElement;
}

export const DrawerDownIcon: TOC<DrawerDownIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M0 6H12V9H0V6ZM12 11H0V14H12V11ZM12 16H0V19H12V16ZM20.3 15.6L22.6 13.3L24 14.7L19.3 19.4L14.6 14.7L16 13.3L18.3 15.6V6H20.3V15.6Z"/>
</svg>
</template>;